import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLockOpen, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Utils } from '../../Services/Utils';
import { LoginScene, AuthCard } from './LoginScene';

const ForgotPasswordComponent: React.FC = () => {
    useEffect(() => {
        Utils.setDocumentTitle('Zabudnuté heslo');
    }, []);

    const navigate = useNavigate();

    return (
        <LoginScene>
            <AuthCard title="Zabudnuté heslo">
                <div className="text-center">
                    <div className="st-forgot-password-icon">
                        <FontAwesomeIcon icon={faLockOpen} />
                    </div>

                    <p className="st-forgot-password-text">
                        Kontaktujte správcu systému pre obnovenie hesla.
                    </p>

                    <button
                        onClick={() => navigate('/')}
                        className="st-btn st-btn--fill w-100"
                    >
                        <FontAwesomeIcon icon={faArrowLeft} className="st-forgot-password-back-icon" />
                        Späť na prihlásenie
                    </button>
                </div>
            </AuthCard>
        </LoginScene>
    );
};

export default ForgotPasswordComponent;
